<template>
  <div>
    <MainLayout>
      <template v-if="currentPipelineReview" #title-adjacent>
        <StatusBadge :status="currentPipelineReview.status" />
      </template>
      <div v-if="loaded && teammate" class="flex justify-between items-start gap-4">
        <div class="lg:w-2/3">
          <Card>
            <CardContent>
              <ReviewDisplay :pipeline-review="{ id: reviewId }" :teammate="teammate" />
            </CardContent>
          </Card>
        </div>

        <div class="lg:w-1/3">
          <EventRecordingCard :event-recording="eventRecording" />
          <TeammateInfoCard :teammate="teammate" />
          <AttachmentsCard v-if="currentPipelineReview" class="mt-6" :pipeline-review="currentPipelineReview" />
        </div>
      </div>
    </MainLayout>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import MainLayout from '@/components/layouts/MainLayout/index.vue';
import { Card, CardContent } from '@/components/ui/card';
import ReviewDisplay from '@/components/shared/pipeline_reviews/ReviewDisplay.vue';
import AttachmentsCard from './AttachmentsCard.vue';
import EventRecordingCard from './EventRecordingCard.vue';
import TeammateInfoCard from './TeammateInfoCard.vue';
import { Api } from '@/api';
import type { PipelineReviewShowRecord } from '@/api/pipeline_reviews';
import type { EventRecordingEntity } from '@/api/entity_types/EventRecording';
import StatusBadge from '@/components/shared/pipeline_reviews/StatusBadge.vue';

const route = useRoute();

const contactId = Number(route.params.contactId);
const reviewId = Number(route.params.id);

const loaded = ref(false);
const teammate = ref<{ id: number; name: string; email: string; phone_number: string } | null>(null);
const currentPipelineReview = ref<PipelineReviewShowRecord | null>(null);
const eventRecording = ref<EventRecordingEntity | null>(null);

onMounted(async () => {
  const [reviewData, contactData] = await Promise.all([
    Api.PipelineReviews.getPipelineReview(contactId, reviewId),
    Api.Contacts.getContact(String(contactId)),
  ]);

  if (reviewData.status === 'success') {
    currentPipelineReview.value = reviewData.data.pipeline_review;
    eventRecording.value = reviewData.data.contact_event?.event_recording ?? null;
  }
  teammate.value = contactData?.record;
  loaded.value = true;
});
</script>
